import { createSlice, PayloadAction, current } from "@reduxjs/toolkit";
import { DtoSettingsData } from "../dto/settings.dto";

const defaultValue: DtoSettingsData = {
    links: "",
    name: "",
    domain: "",
    logo: "",
    callerTune:"",
    id: null,
    call_timeout: "",
    // application_id:"",
    // company_id:"",
    // storageapi_key:"",
    // ssm_user_id:"",
    // ssm_password:"",
    // hummingBirdOrSSM : "",
    notification_timeout:"",
    ringTone:"",
    ssm_api_base_url: "",
    fetchedCustomerData: [],
    voiceCallCustomerDetails: null
};

export const settingsSlice = createSlice({
    name: "settings",
    initialState: defaultValue,
    reducers: {
        setSettingsData: (state, action) => {
            state.links = action.payload.links;
            state.name = action.payload.name;
            state.domain = action.payload.domain;
            state.logo = action.payload.logo;
            state.callerTune = action.payload.callerTune;
            state.id = action.payload.id ? action.payload.id : null;
            state.call_timeout = action.payload.call_timeout ;
            // state.application_id = action.payload.application_id;
            // state.company_id = action.payload.company_id;
            // state.storageapi_key = action.payload.storageapi_key;
            // state.hummingBirdOrSSM = action.payload.hummingBirdOrSSM;
            // state.ssm_user_id = action.payload.ssm_user_id;
            // state.ssm_password = action.payload.ssm_password;
            state.notification_timeout = action.payload.notification_timeout;
            state.ringTone = action.payload.ringTone;
            state.ssm_api_base_url = action.payload.ssm_api_base_url;
        },
        clearLinksData: (state) => {
            state.links = "";
            state.name = "";
            state.domain = "";
            state.logo = "";
            state.callerTune = "";
            state.id = null;
            state.call_timeout = "";
            // state.application_id = "";
            // state.company_id = "";
            // state.storageapi_key = "";
            // state.hummingBirdOrSSM = "";
            // state.ssm_user_id = "";
            // state.ssm_password = "";
            state.ringTone = "";
            state.ssm_api_base_url = "";
        },
        setFetchedCustomerData: (state, action: PayloadAction<any[]>) => {
            state.fetchedCustomerData = action.payload;
        },
        clearFetchedCustomerData: (state) => {
            state.fetchedCustomerData = [];
        },
        setVoiceCallCustomerDetails: (state, action: PayloadAction<any>) => {
            state.voiceCallCustomerDetails = action.payload;
        },
        clearVoiceCallCustomerDetails: (state) => {
            state.voiceCallCustomerDetails = null;
        },
    },
});

export const settingsStateValue = (state: any) => state;

export const { setSettingsData, clearLinksData, setFetchedCustomerData, clearFetchedCustomerData, setVoiceCallCustomerDetails, clearVoiceCallCustomerDetails } = settingsSlice.actions;

export default settingsSlice.reducer;
